exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-box {\n    padding: 16px 20px;\n    background-color: #f7f7f9;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n\tborder: 1px solid rgba(0,0,0,.125); \n}\n.contact-add-data {\n    /* border-top: 1px solid rgba(0,0,0,.125);\n    margin-top: 15px; */\n    padding-top: 15px;\n    clear: both;\n}\n.content-btn-grp input {\n    width: calc(100% - 40px);\n    height: 40px;\n    border: 1px solid #ddd;\n    display: inline-block;\n    vertical-align: middle;\n\tpadding: 5px 10px;\n}\n.contact-add-data .iconButton {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n}\n.form-group {\n    padding: 16px 20px;\n    margin: 0;\n}\n\n.name-box input {\n\twidth:100%;\n\tborder: 1px solid #ddd;\n\theight: 40px;\n\tpadding: 5px 10px;\n\tmargin-top:15px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/contact-us-add/contact-us-add.component.css
// module id = ../../../../../src/app/event/contact-us-add/contact-us-add.component.css
// module chunks = main